/** Yakuniy reytingni PNG qilib yuklab beradi (canvas, no deps). */

function roundRect(ctx, x, y, w, h, r) {
  const radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius);
  ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius);
  ctx.closePath();
}

function initials(name) {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function drawAvatar(ctx, cx, cy, r, name, crowned) {
  if (crowned) {
    ctx.fillStyle = '#FFD54A';
    ctx.beginPath();
    ctx.moveTo(cx - 14, cy - r - 4);
    ctx.lineTo(cx - 10, cy - r - 16);
    ctx.lineTo(cx - 2, cy - r - 8);
    ctx.lineTo(cx, cy - r - 20);
    ctx.lineTo(cx + 2, cy - r - 8);
    ctx.lineTo(cx + 10, cy - r - 16);
    ctx.lineTo(cx + 14, cy - r - 4);
    ctx.closePath();
    ctx.fill();
  }

  const grd = ctx.createLinearGradient(cx - r, cy - r, cx + r, cy + r);
  grd.addColorStop(0, '#00FF85');
  grd.addColorStop(1, '#1a9e6a');
  ctx.fillStyle = grd;
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = '#121a21';
  ctx.beginPath();
  ctx.arc(cx, cy, r - 3, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = '#f4f7f5';
  ctx.font = `800 ${Math.floor(r * 0.7)}px "Plus Jakarta Sans", system-ui, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(initials(name), cx, cy + 1);
}

function drawBlock(ctx, x, y, w, h, place) {
  const colors = {
    1: ['#8fffc4', '#00ff85', '#00b85f'],
    2: ['#b8c4d0', '#8a96a4', '#6a7684'],
    3: ['#e0a878', '#c47a48', '#a05a32'],
  };
  const [c0, c1, c2] = colors[place] || colors[2];
  const g = ctx.createLinearGradient(x, y, x, y + h);
  g.addColorStop(0, c0);
  g.addColorStop(0.45, c1);
  g.addColorStop(1, c2);
  ctx.fillStyle = g;
  roundRect(ctx, x, y, w, h, 14);
  ctx.fill();

  ctx.fillStyle = place === 1 ? '#06110c' : 'rgba(255,255,255,0.92)';
  ctx.font = `800 ${Math.floor(h * 0.42)}px "Plus Jakarta Sans", system-ui, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(String(place), x + w / 2, y + h / 2 + 2);
}

/**
 * @param {Array<{name:string, score:number}>} ranked
 * @param {{ roomID?: string }} [opts]
 * @returns {Promise<void>}
 */
export async function downloadLeaderboardPng(ranked, opts = {}) {
  if (!ranked || ranked.length === 0) return;

  const dpr = Math.min(window.devicePixelRatio || 2, 2);
  const width = 720;
  const pad = 36;
  const rowH = 56;
  const podiumH = 260;
  const headerH = 100;
  const footerH = 56;
  const height =
    headerH + podiumH + 24 + ranked.length * rowH + 28 + footerH;

  const canvas = document.createElement('canvas');
  canvas.width = Math.floor(width * dpr);
  canvas.height = Math.floor(height * dpr);
  const ctx = canvas.getContext('2d');
  ctx.scale(dpr, dpr);

  // Background
  ctx.fillStyle = '#0d1317';
  ctx.fillRect(0, 0, width, height);
  const bgGlow = ctx.createRadialGradient(
    width * 0.5,
    80,
    20,
    width * 0.5,
    120,
    320
  );
  bgGlow.addColorStop(0, 'rgba(0,255,133,0.12)');
  bgGlow.addColorStop(1, 'rgba(0,255,133,0)');
  ctx.fillStyle = bgGlow;
  ctx.fillRect(0, 0, width, 280);

  // Brand
  ctx.fillStyle = '#00FF85';
  roundRect(ctx, pad, 28, 36, 36, 10);
  ctx.fill();
  ctx.fillStyle = '#0d1317';
  ctx.font = '800 22px "Plus Jakarta Sans", system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText('1', pad + 18, 47);

  ctx.fillStyle = '#f4f7f5';
  ctx.font = '700 22px "Plus Jakarta Sans", system-ui, sans-serif';
  ctx.textAlign = 'left';
  ctx.fillText('Menbirinchi', pad + 48, 46);

  ctx.fillStyle = '#f4f7f5';
  ctx.font = '700 28px "Plus Jakarta Sans", system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.fillText('Reyting', width / 2, 88);

  // Podium: visual 2 | 1 | 3
  const top = ranked.slice(0, 3);
  const slots = [
    top[1] ? { p: top[1], place: 2 } : null,
    top[0] ? { p: top[0], place: 1 } : null,
    top[2] ? { p: top[2], place: 3 } : null,
  ].filter(Boolean);

  const stageTop = 118;
  const colW = 180;
  const gap = 16;
  const totalW = slots.length * colW + (slots.length - 1) * gap;
  let sx = (width - totalW) / 2;

  const blockH = { 1: 120, 2: 92, 3: 72 };

  slots.forEach(({ p, place }) => {
    const bh = blockH[place];
    const blockY = stageTop + podiumH - bh - 8;
    const cx = sx + colW / 2;
    const avR = place === 1 ? 36 : 28;
    const avY = blockY - 70;

    drawAvatar(ctx, cx, avY, avR, p.name, place === 1);

    ctx.fillStyle = '#f4f7f5';
    ctx.font = '600 15px "Plus Jakarta Sans", system-ui, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    const name =
      p.name.length > 14 ? `${p.name.slice(0, 13)}…` : p.name;
    ctx.fillText(name, cx, avY + avR + 22);

    ctx.fillStyle = place === 1 ? '#00FF85' : '#8b97a3';
    ctx.font = '700 13px "Plus Jakarta Sans", system-ui, sans-serif';
    ctx.fillText(`${p.score} ball`, cx, avY + avR + 40);

    drawBlock(ctx, sx + 18, blockY, colW - 36, bh, place);
    sx += colW + gap;
  });

  // List card
  const listY = headerH + podiumH + 8;
  const listH = ranked.length * rowH + 28;
  ctx.fillStyle = '#0f161c';
  ctx.strokeStyle = 'rgba(0,255,133,0.28)';
  ctx.lineWidth = 1.5;
  roundRect(ctx, pad, listY, width - pad * 2, listH, 24);
  ctx.fill();
  ctx.stroke();

  // handle
  ctx.fillStyle = 'rgba(255,255,255,0.14)';
  roundRect(ctx, width / 2 - 20, listY + 10, 40, 4, 2);
  ctx.fill();

  ranked.forEach((p, i) => {
    const y = listY + 24 + i * rowH;
    const place = i + 1;

    if (place <= 3) {
      const medalColors = {
        1: '#FFD54A',
        2: '#C0C8D0',
        3: '#E08950',
      };
      ctx.fillStyle = medalColors[place];
      ctx.beginPath();
      ctx.arc(pad + 28, y + rowH / 2 - 4, 14, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#0d1317';
      ctx.font = '800 13px "Plus Jakarta Sans", system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(String(place), pad + 28, y + rowH / 2 - 3);
    } else {
      ctx.fillStyle = '#8b97a3';
      ctx.font = '700 15px "Plus Jakarta Sans", system-ui, sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(String(place), pad + 28, y + rowH / 2 - 4);
    }

    // small avatar
    ctx.fillStyle = '#1a2430';
    ctx.beginPath();
    ctx.arc(pad + 64, y + rowH / 2 - 4, 16, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#f4f7f5';
    ctx.font = '800 11px "Plus Jakarta Sans", system-ui, sans-serif';
    ctx.fillText(initials(p.name), pad + 64, y + rowH / 2 - 3);

    ctx.fillStyle = '#f4f7f5';
    ctx.font = '600 16px "Plus Jakarta Sans", system-ui, sans-serif';
    ctx.textAlign = 'left';
    ctx.textBaseline = 'middle';
    const nm = p.name.length > 22 ? `${p.name.slice(0, 21)}…` : p.name;
    ctx.fillText(nm, pad + 90, y + rowH / 2 - 4);

    ctx.fillStyle = '#f4f7f5';
    ctx.font = '700 16px "Plus Jakarta Sans", system-ui, sans-serif';
    ctx.textAlign = 'right';
    ctx.fillText(`${p.score}`, width - pad - 18, y + rowH / 2 - 4);
    const scoreW = ctx.measureText(`${p.score}`).width;
    ctx.fillStyle = '#8b97a3';
    ctx.font = '500 12px "Plus Jakarta Sans", system-ui, sans-serif';
    ctx.fillText(' ball', width - pad - 18 - scoreW, y + rowH / 2 - 4);
  });

  // Footer
  ctx.fillStyle = '#8b97a3';
  ctx.font = '500 13px "Plus Jakarta Sans", system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  const roomBit = opts.roomID ? ` · ${opts.roomID}` : '';
  ctx.fillText(`menbirinchi.uz${roomBit}`, width / 2, height - 28);

  const blob = await new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), 'image/png');
  });
  if (!blob) return;

  const stamp = new Date().toISOString().slice(0, 10);
  const room = opts.roomID ? `-${opts.roomID}` : '';
  const filename = `menbirinchi-reyting${room}-${stamp}.png`;

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
